import { styled } from 'baseui'

export const VoterTable = styled('ul', ({ $theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  paddingLeft: 0,
  listStyleType: 'none',
  borderTop: `1px solid ${$theme.colors.borderPulse}`,
}))
